import { DatePicker, Form, Row } from "antd";
import { DATE_FORMAT } from "../../../../../../../lib/constants";
import { useMemo } from "react";
import { Rule } from "antd/es/form";
import TextArea from "antd/es/input/TextArea";
import { useTextFieldRules } from "../../hooks/useTextFieldRules";
import dayjs, { Dayjs } from "dayjs";

export const IncidentNature = () => {
  const { longTextRules } = useTextFieldRules();

  const dateRules: Rule[] = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: Dayjs) {
          if (!value) {
            return Promise.reject(new Error("Please enter Incident Date"));
          }

          const current = value.startOf("D");
          const maxDate = dayjs().startOf("D");

          if (maxDate.diff(current) < 0) {
            return Promise.reject(
              new Error(
                `Date must not be greater than ${maxDate.format(DATE_FORMAT)}`,
              ),
            );
          }

          return Promise.resolve("");
        },
      }),
    ];
  }, []);

  const descRules: Rule[] = useMemo(
    () => [{ required: true, validateTrigger: "onSubmit" }, longTextRules[0]],
    [longTextRules],
  );

  const autoSize = useMemo(() => ({ minRows: 4 }), []);

  return (
    <Row className="d-block w-100 pb-6">
      <p className="mt-0 mb-4 text w-500">Nature of the Incident</p>
      <Form.Item
        label="Incident Date"
        name="date"
        className="mb-4 "
        rules={dateRules}
      >
        <DatePicker format={DATE_FORMAT} placeholder="MM/DD/YY" />
      </Form.Item>
      <Form.Item
        label="Incident Description"
        name="description"
        rules={descRules}
      >
        <TextArea
          autoSize={autoSize}
          placeholder="What happened, the client’s concerns, and any specific issues that where addressed"
        />
      </Form.Item>
    </Row>
  );
};
